module.exports = {
	"id": "PS",
	"name": "Palestinian Territory",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.006364,
			"11": 0.038184,
			"12": 0.019092,
			"13": null,
			"14": 0.012728,
			"15": 0.012728,
			"16": 0.038184,
			"17": 0.006364,
			"18": 0.019092,
			"19": 0.012728,
			"20": 0.006364,
			"21": 0.019092,
			"22": 0.025456,
			"23": 0.006364,
			"24": 0.050912,
			"25": 0.025456,
			"26": 0.03182,
			"27": 0.038184,
			"28": 0.019092,
			"29": 0.03182,
			"30": 0.044548,
			"31": 0.210012,
			"32": 0.06364,
			"33": 0.210012,
			"34": 0.03182,
			"35": 0.012728,
			"36": 0.012728,
			"37": 0.089096,
			"38": 0.050912,
			"39": 0.044548,
			"40": 0.076368,
			"41": 0.03182,
			"42": 0.03182,
			"43": 0.973692,
			"44": 0.12728,
			"45": 0.06364,
			"46": 0.09546,
			"47": 0.114552,
			"48": 0.1591,
			"49": 2.539236,
			"50": 0.22274,
			"51": 1.17734,
			"52": 0.642764,
			"53": 29.509868,
			"54": 9.546,
			"55": 0.09546,
			"56": 0.09546,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.012728,
			"4": null,
			"5": null,
			"6": 0.03182,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.006364,
			"11": 0.012728,
			"12": 0.050912,
			"13": null,
			"14": null,
			"15": 0.025456,
			"16": 0.03182,
			"17": null,
			"18": 0.012728,
			"19": 0.012728,
			"20": null,
			"21": 0.006364,
			"22": 0.006364,
			"23": null,
			"24": null,
			"25": 0.012728,
			"26": 0.019092,
			"27": null,
			"28": null,
			"29": 0.012728,
			"30": 0.012728,
			"31": 0.019092,
			"32": 0.038184,
			"33": 0.012728,
			"34": 0.019092,
			"35": 0.03182,
			"36": 0.089096,
			"37": 0.03182,
			"38": 0.057276,
			"39": 0.025456,
			"40": 0.070004,
			"41": 0.03182,
			"42": 0.03182,
			"43": 0.292744,
			"44": 0.076368,
			"45": 0.28638,
			"46": 0.1591,
			"47": 0.808228,
			"48": 0.553668,
			"49": 5.638504,
			"50": 0.12728,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.06364
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.03182,
			"34": null,
			"35": 0.012728,
			"36": 0.050912,
			"37": 0.03182,
			"38": 0.082732,
			"39": 0.012728,
			"40": 0.706404,
			"41": 0.09546,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.674584
		},
		"safari": {
			"0": null,
			"4": 0.012728,
			"5": 0.012728,
			"6": null,
			"7": null,
			"8": 0.089096,
			"9": 0.038184,
			"10": 0.330928,
			"3.1": null,
			"3.2": null,
			"5.1": 0.050912,
			"6.1": null,
			"7.1": null,
			"9.1": 0.496392
		},
		"ios_saf": {
			"8": 0,
			"10": 2.45257172773,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0660939701291,
			"8.1-8.4": 0.122105809221,
			"9.0-9.2": 0.0582523126561,
			"9.3": 0.888721180266
		},
		"android": {
			"3": 0,
			"4": 0.0813977002584,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0101747125323,
			"4.1": 0.293613133075,
			"4.2-4.3": 0.734032832687,
			"4.4": 1.68318815891,
			"4.4.3-4.4.4": 1.69772346253
		},
		"ie": {
			"6": 0.00669119794344,
			"7": 0.00669119794344,
			"8": 0.802943753213,
			"9": 0.247574323907,
			"10": 0.147206354756,
			"11": 1.38507797429,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0990182900929,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00275050805814
		},
		"edge": {
			"12": 0.070004,
			"13": 0.248196,
			"14": 0.375476
		},
		"ie_mob": {
			"10": 0.0293871830986,
			"11": 0.119647816901
		},
		"bb": {
			"7": 0.0018175,
			"10": null
		},
		"samsung": {
			"0": 3.56957
		},
		"and_uc": {
			"0": 0.207195
		},
		"op_mini": {
			"0": 1.33405620185
		},
		"and_chr": {
			"0": 23.588828
		},
		"and_ff": {
			"0": 0.025445
		}
	},
	"total": 98.5096833021
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/PS.json
 ** module id = 627
 ** module chunks = 0
 **/